import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";

import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const HistoryPaymentPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/desktop/pages/HistoryPayment"
    ),
  loading: LoadableLoading
});
const HistoryPaymentPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/desktop/pages/HistoryPayment"
    ),
  loading: LoadableLoading
});

class DetectHistoryPayment extends Component {
  methods = {
    handleGoBack: () => {
      const { history } = this.props;
      history.push("/");
    }
  };

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <HistoryPaymentPageMobile {...this.props} {...this.methods} />
        ) : (
          <HistoryPaymentPageDesktop {...this.props} {...this.methods} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    fee: { listHistoryPayment }
  } = state;
  return {
    device: type,
    listHistoryPayment
  };
};

const HistoryPaymentHelmet = withTitle({
  component: DetectHistoryPayment,
  title: `${hospitalName.value} | Lịch sử thanh toán viện phí`
});

export default connect(mapStateToProps)(HistoryPaymentHelmet);
